import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum ServiceTemplateScheduleOccurrencesColumn {
    INDEX = "index",
    APPLICATION_DATE = "applicationDate",
    SERVICE_START = "serviceStart",
    SERVICE_END = "serviceEnd",
    WORK_START = "workStart",
    WORK_END = "workEnd",
    PREPARER = "preparer",
    REVIEWER = "reviewer",
    MANAGER = "manager",
    CLIENT = "client",
    ESTIMATED_TIME = "estimatedTime",
    STATUS = "status",
    ACTIONS = "actions",
}

export enum ServiceTemplateScheduleOccurrencesSortValue {
    INDEX_ASC = "INDEX_ASC",
    INDEX_DESC = "INDEX_DESC",
    APPLICATION_DATE_ASC = "APPLICATION_DATE_ASC",
    APPLICATION_DATE_DESC = "APPLICATION_DATE_DESC",
    SERVICE_START_ASC = "SERVICE_START_ASC",
    SERVICE_START_DESC = "SERVICE_START_DESC",
    SERVICE_END_ASC = "SERVICE_END_ASC",
    SERVICE_END_DESC = "SERVICE_END_DESC",
    WORK_START_ASC = "WORK_START_ASC",
    WORK_START_DESC = "WORK_START_DESC",
    WORK_END_ASC = "WORK_END_ASC",
    WORK_END_DESC = "WORK_END_DESC",
    STATUS_ASC = "STATUS_ASC",
    STATUS_DESC = "STATUS_DESC",
}

const makeColumnSchema = (id: ServiceTemplateScheduleOccurrencesColumn) =>
    ColumnSchema.extend({ id: z.literal(id) });

export const ServiceTemplateScheduleOccurrencesViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.SERVICE_TEMPLATE_SCHEDULE_OCCURRENCES),
    columns: z.array(
        z.discriminatedUnion("id", [
            makeColumnSchema(ServiceTemplateScheduleOccurrencesColumn.INDEX),
            makeColumnSchema(
                ServiceTemplateScheduleOccurrencesColumn.APPLICATION_DATE,
            ),
            makeColumnSchema(
                ServiceTemplateScheduleOccurrencesColumn.SERVICE_START,
            ),
            makeColumnSchema(
                ServiceTemplateScheduleOccurrencesColumn.SERVICE_END,
            ),
            makeColumnSchema(
                ServiceTemplateScheduleOccurrencesColumn.WORK_START,
            ),
            makeColumnSchema(ServiceTemplateScheduleOccurrencesColumn.WORK_END),
            makeColumnSchema(ServiceTemplateScheduleOccurrencesColumn.PREPARER),
            makeColumnSchema(ServiceTemplateScheduleOccurrencesColumn.REVIEWER),
            makeColumnSchema(ServiceTemplateScheduleOccurrencesColumn.MANAGER),
            makeColumnSchema(ServiceTemplateScheduleOccurrencesColumn.CLIENT),
            makeColumnSchema(
                ServiceTemplateScheduleOccurrencesColumn.ESTIMATED_TIME,
            ),
            makeColumnSchema(ServiceTemplateScheduleOccurrencesColumn.STATUS),
            makeColumnSchema(ServiceTemplateScheduleOccurrencesColumn.ACTIONS),
        ]),
    ),
});

export type ServiceTemplateScheduleOccurrencesView = z.infer<
    typeof ServiceTemplateScheduleOccurrencesViewSchema
>;
